module.exports = __webpack_public_path__ + "static/media/i-info.477d7275.svg";